<template>
        <SearchObject
        :additional-params="{ ordering: 'full_name', ...additionalParams }"
        :allow-create="false"
        :autofocus="autofocus"
        :base-url="baseUrl"
        :disabled="disabled"
        :hide-details="hideDetails"
        :item-text="itemText"
        :label="label || $translate('select_user')"
        :readonly="readonly"
        :required="required"
        :value="value"
        :limit="limit"
        :dense="dense"
        :outlined="outlined"
        :flat="flat"
        :icon="icon"
        @input="$emit('input', $event)"
        @select="$emit('select', $event)"
        :error-messages="errorMessages"
            ref="search"
    >
        <template slot="item" slot-scope="{ item }">
            <div class="d-flex flex-column py-2">
                <div class="text-body-2 font-weight-bold">
                    {{ displayName(item) }}
                </div>
                <div v-if="item.email" class="text-caption text--secondary">
                    {{ item.email }}
                </div>
            </div>
        </template>
    </SearchObject>
</template>

<script>
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "SearchUser",
    props: {
        baseUrl: {
            type: String,
            default: "/api/users/",
        },
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        label: {
            type: String,
            default: "",
        },
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
    },
    methods: {
        itemText(item) {
            return this.displayName(item);
        },
        displayName(item) {
            const name =
                item.full_name ||
                `${item.first_name || ""} ${item.last_name || ""}`.trim();
            return name || item.username || item.email || "";
        },
        focus() {
            this.$refs.search && this.$refs.search.focus();
        },
    },
    i18n: {
        messages: {
            en: {
                select_user: "Select a user",
            },
            fr: {
                select_user: "Sélectionnez un utilisateur",
            },
        },
    },
};
</script>


